import React from 'react';
import * as LucideIcons from 'lucide-react';

export const Highlights = ({ highlights }) => {
  return (
    <section className="section-padding container-padding bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {highlights.map((highlight, index) => {
            const IconComponent = LucideIcons[highlight.icon] || LucideIcons.Star;
            const colorClass = index % 2 === 0 ? 'icon-green' : 'icon-purple';
            
            return (
              <div
                key={index}
                className={`text-center card-hover animate-fade-in-up stagger-${index + 1}`}
              >
                <div className={`${colorClass} w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4`}>
                  <IconComponent className="w-8 h-8" />
                </div>
                <h3 className="text-xl font-bold mb-3 text-gray-900">
                  {highlight.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {highlight.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
